
const SeaportLogo = () => (
  <div>
    <img
      src="/assets/img/seaportopx.logo.png"
      alt="Seaport OPX"
      height={100}
    />
  </div>
);

export default SeaportLogo;
